import React from "react";
import { Icon as AntIcon } from "antd";

const Icon = (props) => (
  <AntIcon {...props} style={props.style} type={props.type} />
);

export default Icon;
